import React, { Component , Suspense } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import VignetteCheck from './components/VignetteCheck/VignetteCheck';
import ViolationCheck from './components/ViolationCheck/ViolationCheck';
import PaymentForm from './components/CustomTable/PaymentForm';
import PaymentBorica from './components/PaymentBorica/PaymentBorica';
//import PaymentInfo from './components/PaymentInfo/PaymentInfo';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import NotFound from './components/NotFound/NotFound';
import { BigSpinner } from './components/BigSpinner/BigSpinner';

class App extends Component {
  render() {
    return (
        <HashRouter>
          <Suspense fallback={<BigSpinner />}>
            <div className="App">
              <Header />
              <Switch>
                  <Route exact path="/form/:delictId" component={PaymentForm} />
                  <Route exact path="/" component={VignetteCheck} />
                  <Route exact path="/vignette" component={VignetteCheck} />
                  <Route exact path="/payment/status/:delictId" component={PaymentBorica} />
                  <Route path="/violation" component={ViolationCheck} />
                  {/* <Route exact path="/payment" component={PaymentInfo} /> */}
                  {/* <Route path='/payment' component={() => { 
                    
                    return null;
                  }}/> */}
                  <Route path="*" component={NotFound} />
              </Switch>
            </div>
            <Footer />
          </Suspense>
        </HashRouter>
    );
  }
}

export default App;
